import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Page404 from "./pages/Page404";
import Main from "./pages/Main";
import Buy from "./pages/Buy";
import Settings from "./pages/Settings";
import Paid from "./pages/Paid";
import ParkingSession from "./pages/ParkingSession";
import NewVehicle from "./pages/Save/NewVehicle";
import RemoveVehicle from "./pages/Save/RemoveVehicle";
import RemoveCard from "./pages/Save/RemoveCard";
import ProcessPaymentByCard from "./pages/Payment/ProcessPaymentByCard";
import NewEmail from "./pages/Save/NewEmail";
import RemoveEmail from "./pages/Save/RemoveEmail";
import { PreviousLocationProvider } from "./hooks/PreviousLocationContext";
import MaintenanceLayout from "./pages/Maintenance/MaintenanceLayout";
import Gdpr from "./pages/Gdpr";
import Cookies from "./pages/Cookies";
import LegalInformation from "./pages/LegalInformation";
import { Helmet } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Documents from "pages/Documents/Documents";
import VersionInformation from "./pages/VersionInformation";
import MaintenanceContent from "./pages/Maintenance/MaintenanceContent";

const websiteUrl = window._env_.REACT_APP_WEB_URL;

const queryClient = new QueryClient();

export default function App() {
    if (window._env_.REACT_APP_MAINTENANCE_MODE === "true") {
        return (
            <>
                <Helmet>
                    <script defer data-domain={websiteUrl} src="https://plausible.io/js/script.js"></script>
                </Helmet>
                <BrowserRouter>
                    <PreviousLocationProvider>
                        <QueryClientProvider client={queryClient}>
                            <Routes>
                                <Route path="/" element={<MaintenanceLayout />}>
                                    <Route index element={<MaintenanceContent />} />
                                    <Route path={"/legal-information"} element={<LegalInformation />} />
                                    <Route path={"/version-information"} element={<VersionInformation />} />

                                    <Route path={"/paid/:ticketGUID"} element={<Paid />} />
                                    <Route path={"/parking-session/:ticketGUID"} element={<ParkingSession />} />
                                    <Route path={"*"} element={<MaintenanceContent />} />
                                </Route>
                            </Routes>
                        </QueryClientProvider>
                    </PreviousLocationProvider>
                </BrowserRouter>
            </>
        );
    }

    return (
        <>
            <Helmet>
                <script defer data-domain={websiteUrl} src="https://plausible.io/js/script.js"></script>
            </Helmet>
            <BrowserRouter>
                <PreviousLocationProvider>
                    <QueryClientProvider client={queryClient}>
                        <Routes>
                            <Route path="/" element={<Layout />}>
                                <Route index element={<Main />} />
                                <Route path={"/pz/:sectionCode"} index element={<Main />} />
                                <Route path={"/ib/:sectionCode"} index element={<Main />} />
                                <Route path={"/pm/:sectionCode"} index element={<Main />} />

                                <Route path={"/buy/:featureType/:sectionCode"} element={<Buy />} />

                                <Route path={"/payment/process"} element={<ProcessPaymentByCard />} />
                                <Route path={"/payment/zp/:token"} element={<ProcessPaymentByCard zeroPay={true} />} />
                                <Route path={"/payment/token/:token"} element={<ProcessPaymentByCard token={true} />} />
                                <Route path={"/payment/applepay/:token"} element={<ProcessPaymentByCard applepay={true} />} />
                                <Route path={"/payment/googlepay/:token"} element={<ProcessPaymentByCard googlepay={true} />} />

                                <Route path={"/settings"} element={<Settings />} />
                                <Route path={"/settings/email/new"} element={<NewEmail />} />
                                <Route path={"/settings/vehicle/new"} element={<NewVehicle />} />
                                <Route path={"/settings/vehicle/remove/:vehicleId"} element={<RemoveVehicle />} />
                                <Route path={"/settings/email/remove/:emailId"} element={<RemoveEmail />} />
                                <Route path={"/settings/card/remove/:maskedCLN"} element={<RemoveCard />} />

								<Route path={"/documents"} element={<Documents />} />

                                <Route path={"/gdpr"} element={<Gdpr />} />

                                <Route path={"/cookies"} element={<Cookies />} />

                                <Route path={"/legal-information"} element={<LegalInformation />} />
                                <Route path={"/version-information"} element={<VersionInformation />} />

                                {/* TODO: Přidat asi parametr z API a načíst si potřebný věci */}
                                <Route path={"/paid/:ticketGUID"} element={<Paid />} />
                                <Route path={"/parking-session/:ticketGUID"} element={<ParkingSession />} />
                                <Route path={"*"} element={<Page404 />} />
                            </Route>
                        </Routes>
                    </QueryClientProvider>
                </PreviousLocationProvider>
            </BrowserRouter>
        </>
    );
}
